import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';

import { CourseLink } from '../../../shared/links/ProfileLink';
import Abbr from '../../../shared/Abbr';
import { formatMoney } from '../../../utils/money';

const CourseCell = ({
    courseName,
    courseUid,
    courseRpAbbrev3,
    distanceFurlong,
    goingTypeCode,
    raceDescription,
    prizeMoney,
}) => (
    <span>
        <CourseLink
            courseStyleName={courseName}
            courseUid={courseUid}
        >
            <Abbr title={courseName}>{capitalize(courseRpAbbrev3)}</Abbr>
        </CourseLink>
        <span className="hidden-xs-down">
            {` ${distanceFurlong}${goingTypeCode}`}
            &nbsp;{`C${raceDescription}`}
            &nbsp;{formatMoney(prizeMoney)}
        </span>
    </span>
);

CourseCell.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    courseRpAbbrev3: PropTypes.string,
    distanceFurlong: PropTypes.number,
    goingTypeCode: PropTypes.string,
    raceDescription: PropTypes.string,
    prizeMoney: PropTypes.number,
};

export default CourseCell;



// WEBPACK FOOTER //
// ./src/js/horse/progenyResults/components/CourseCell.jsx